import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/element.js';
import './assets/css/global.css';
import './assets/css/element.css';
import './assets/css/fonts.css';
import './assets/css/echarts.css';
import './assets/fonts/iconfont.css';
// import 'lib-flexible/flexible.js'
import axios from 'axios';
import { Message } from 'element-ui';
import { throttle } from './utils';

// import echarts from 'echarts'

import { setCookie, delCookie } from './assets/cookie';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import VueCookies from 'vue-cookies';

import Print from 'vue-print-nb';

import JsonExcel from 'vue-json-excel';
Vue.component('downloadExcel', JsonExcel);

Vue.use(Print);

Vue.prototype.$echarts = window.echarts;
Vue.prototype.$Plotly = window.Plotly;

Vue.prototype.$eventBus = new Vue();

Vue.prototype.$CHloading = null;

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = '';
} else {
  axios.defaults.baseURL = 'https://database.chopinsight.cn/';
  // axios.defaults.baseURL = 'https://api.chopinsight.cn/';
  if (window) {
    // window.console.log = function () {};
  }
  // axios.defaults.baseURL = '/'
}
// 本地联调连接远程数据库，首次加载常会超过 8 秒；生产环境仍保持原限制。
const isLocalDevHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
axios.defaults.timeout = isLocalDevHost ? 60000 : 8000;

//   axios.defaults.baseURL = ''

// import 'amfe-flexible'
Vue.use(VueCookies);

// 显示进度条功能
NProgress.configure({
  easing: 'ease',
  // speed:100,
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3, // 初始化时的最小百分比
});

// 路由前置守卫
router.beforeEach((to, from, next) => {
  const tokenstr = Vue.prototype.$cookies.get('token');

  // 白名单：登录页可以无token访问
  if (to.path === '/login') {
    // 如果已登录，访问登录页则重定向到首页
    if (tokenstr) {
      return next('/home');
    }
    return next();
  }

  // 需要认证的页面：必须要有token
  if (!tokenstr) {
    return next('/login');
  }

  // 正常通过
  startOnlineHeartbeat();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

Vue.prototype.$cookieStore = {
  delCookie,
  setCookie,
};

const throttleLogout = throttle(() => {
  // sessionStorage.clear();
  Vue.prototype.$cookies.remove(
    'token',
    null,
    '.' + window.location.hostname.split('.').slice(-2).join('.')
  );
  router.replace('/login');
  Message({ message: '权限错误：Token无效或登录异常', type: 'error' });
});

let onlineHeartbeatTimer = null;
function startOnlineHeartbeat() {
  // 本地联调时 API 经常重启，服务端内存中的在线会话会随之清空；
  // 此时 JWT 业务鉴权仍有效，不能让在线心跳误判并把页面踢回登录页。
  if (['localhost', '127.0.0.1'].includes(window.location.hostname)) return;
  if (onlineHeartbeatTimer) return;
  onlineHeartbeatTimer = setInterval(() => {
    const token = Vue.prototype.$cookies.get('token');
    if (!token) {
      clearInterval(onlineHeartbeatTimer);
      onlineHeartbeatTimer = null;
      return;
    }
    axios.post('/api/auth/online/ping').catch(() => {});
  }, 10000);
}

// axios.defaults.baseURL='https://erp.rainben.cn/'

// axios.defaults.baseURL = 'https://127.0.0.1:8888/api/private/v1/'
// 挂载axios
Vue.prototype.$https = axios;
axios.defaults.withCredentials = true;

// InsightInday 独立 axios 实例（独立 host，与 conghua 区分）
const inday = axios.create();
inday.defaults.withCredentials = true;
inday.defaults.timeout = isLocalDevHost ? 60000 : 8000;
if (process.env.NODE_ENV === 'development') {
  inday.defaults.baseURL = 'https://insight-inday.chopinsight.cn/';
} else {
  inday.defaults.baseURL = 'https://insight-inday.chopinsight.cn/';
}
inday.interceptors.request.use((config) => {
  let token = Vue.prototype.$cookies.get('token');
  config.headers['x-token'] = `${token}`;
  return config;
});
inday.interceptors.response.use((config) => {
  const msg = (config.data.detail || {}).message || '';
  if (msg.indexOf('权限错误') >= 0) {
    throttleLogout();
    return {};
  }
  return config;
});
Vue.prototype.$inday = inday;

Vue.config.productionTip = false;
// var adc='X-CSRF-TOKEN'
// 请求在到达服务器之前,先会调用use中的这个回调函数来添加请求头信息
axios.interceptors.request.use((config) => {
  // let token = window.sessionStorage.getItem('token');
  let token = Vue.prototype.$cookies.get('token');
  config.headers['x-token'] = `${token}`;
  return config;
});

axios.interceptors.response.use((config) => {
  const msg = (config.data.detail || {}).message || '';
  if (msg.indexOf('权限错误') >= 0) {
    throttleLogout();
    return {};
  }

  return config;
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
